import * as React from "react";

export const WebDate = () => {
  let [dateState, setDateState] = React.useState();
  React.useEffect(() => {
    let months = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
    let webTime = ' в 20:00 мск';
    let now = new Date();
    let update = new Date(Date.UTC(2023, 3, 12, 17, 0, 0, 0)); // month 11 = декабрь, hour 17 = 20:00
    let lastDayOfMonth = new Date(Date.UTC(now.getFullYear(), now.getMonth()+1, 0));

    function isItTime() {
      //узнаем количество секунд, прошедших в текущий день с 00:00
      //для смены даты в 20:00 - по таймеру
      let ourTime = now.getHours() * 3600 + now.getMinutes() * 60 + now.getSeconds();

      //узнаем количество секунд, прошедших в день старта таймера с 00:00, т.е. до 20:00
      let openTime = update.getHours() * 3600 + update.getMinutes() * 60 + update.getSeconds();

      if (ourTime >= openTime) {
        return true;
      } else {
        return false;
      }
    }

    function isLastDayOfMonth() {
      let today = now.getDate();
      let lastDay = lastDayOfMonth.getDate();

      if (today === lastDay) {
        return true;
      } else {
        return false;
      }
    }

    function setDate() {
      let webDay = now.getDate();
      let webMonth = now.getMonth();
      let timerStart = update.getTime() - now.getTime() + 5;
      let openTimeToday = isItTime();
      let lastDay = isLastDayOfMonth();

      if (timerStart < 0) { //общая проверка на соответствие таймеру
        setDateState(`${webDay} ${months[webMonth]}${webTime}`)
        if (openTimeToday && !lastDay) { //проверяем время на 20:00 и на конец месяца
          setDateState(`${webDay + 1} ${months[webMonth]}${webTime}`)
        } else if (openTimeToday && lastDay) {
          if (webMonth !== 11) { //если последний день месяца, то проверяем на конец года
            setDateState(`1 ${months[webMonth + 1]}${webTime}`)
          } else {
            setDateState(`1 января ${webTime}`)
          }
        }
      }
    }

    setDate();

  }, [dateState]);

  return (
    <span>{dateState}</span>
  );
}
